import { render, staticRenderFns } from "./template.html?vue&type=template&id=2d9fcf48&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=2d9fcf48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9fcf48",
  null
  
)

export default component.exports